module.exports = __webpack_public_path__ + "static/media/fun.7ef3c233.jpg";